
import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const addEditMultiExpensesModalSlice = createSlice({
    name: 'addEditMultiExpensesModal',
    initialState: {
        showModal: false,
        title: 'New Multi Expenses',
        editMode: false,
        acc_id: 2,
        formData: {
            multipay_desc: '',
            multipay_date: moment().format('DD-MM-YYYY'),
            multipay_dc: 'C',
            jvtype_id: 33,
            multipay_status: '',
            multipay_value_date: moment().format('DD-MM-YYYY'),
            acc_num: '',
            multipay_ref: '',
            multipay_num: '',
            paymentmode_id: '',
            chart_id: '',
            multipay_doc: '',
            multipayDetails: [],
        }
    },
    reducers: {
        toggleMultiExpensesModal: (state, action) => {
            state.showModal = !state.showModal
            state.title = (action.payload && action.payload.title) ? action.payload.title : 'New Multi Expenses'
            state.editMode = (action.payload && action.payload.editMode) ? action.payload.editMode : false
            state.acc_id = (action.payload && action.payload.acc_id) ? action.payload.acc_id : 2
            state.formData = (action.payload && action.payload.formData) ? { ...action.payload.formData } : {
                multipay_desc: '',
                multipay_date: moment().format('DD-MM-YYYY'),
                multipay_dc: 'C',
                jvtype_id: 33,
                multipay_status: '',
                multipay_value_date: moment().format('DD-MM-YYYY'),
                acc_num: '',
                multipay_ref: '',
                multipay_num: '',
                paymentmode_id: '',
                chart_id: '',
                multipay_doc: '',
                multipayDetails: [],
            }
        }
    },
});

export const { toggleMultiExpensesModal } = addEditMultiExpensesModalSlice.actions;
export default addEditMultiExpensesModalSlice.reducer;
